module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAQCAYAAACLFVaTAAABRklEQVRIibXVvUtcQRjF4WfvLgFrO9MuBjWksgwWgpBeIwTiYmc6mxRiY1IJKZIiZZCAoH9B+hDbVMElWKWz2gjpI8Ri78Lg3kvmQw8MzMd539/hXpjp/PulTSs4RQcvcNbqxNvjN1N7B4PpvRxG1VLcxREeYq6ed/9HTFQ0oy3kc/SDdR+bdxgwidEUsou9hv19PCiOlsHo1eMZnuARlrHY0OAxzvEdFxjiC64jQhUxeviMlxEgmK/HRCeRtUWMChuRxU1aj/QVMSp8K2jwNdJXxKiwZfzvU/UDg0hvEaPCCKv4mVA8xBp+R/qLGJMraISdhAav6poUZTPCe7KX0GAmwRsqixGGbLq32rSQ4A2VxQhDLt0TLFQWI/z8t1+OP3hfz3cxG5z9TYpWyAhDfsBT44f+Ew5xVZ99xGts4xLvMkNmMW4ABY5KtXSOuqMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/2星.png
// module id = rWM5
// module chunks = 1